import { getLabelForNode } from './getLabelForNode'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { ROOT_NODE_ID } from '../../store/migrations/data-structure-conversion'
import { moveCursorTo } from '../../store/cursor'

const PathComponent = ({ node, moveCursorTo }) => {
    let label = getLabelForNode(node.parent)
    label = label.length > 25 ? label.substring(0, 25) + '...' : label
    return (
        <div
            onClick={() => {
                moveCursorTo(node.id)
            }}
        >
            <div className="path-component">{label}</div>
        </div>
    )
}

const PathViewComponent = ({ node, ancestors, moveCursorTo }) => {
    if (!node || node.id === ROOT_NODE_ID) {
        return null
    }
    return (
        <div className="path-view">
            {ancestors.map((ancestor) => {
                return (
                    <Fragment key={ancestor.id}>
                        <PathComponent node={ancestor} moveCursorTo={moveCursorTo} />
                        <div className="path-separator">
                            <i className="far fa-chevron-right" />
                        </div>
                    </Fragment>
                )
            })}
            <PathComponent node={node} moveCursorTo={moveCursorTo} />
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    const getDirectAncestors = (node) => {
        if (!node) return []

        const directAncestors = []
        node = node.parent

        while (node && node.id !== ROOT_NODE_ID) {
            directAncestors.push(node)
            node = node.parent
        }
        return directAncestors.reverse()
    }

    return {
        ...ownProps,
        ancestors: getDirectAncestors(ownProps.node)
    }
}

const mapDispatchToProps = {
    moveCursorTo
}

export const PathView = connect(mapStateToProps, mapDispatchToProps)(PathViewComponent)
